module.exports = __webpack_public_path__ + "img/icon-sku-loading.c9dcf1ff.png";